module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav nav-tabs conversions-tabs"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/conversions/country',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-globe"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.by_country')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/conversions/offers',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-briefcase"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.by_offers')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/conversions/period',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar-o"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.by_period')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/conversions/courier',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-truck"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.by_couriers')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/conversions/graph',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-area-chart"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.by_graph')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/conversions/buyout',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-pie-chart"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.by_pieces')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/conversions/flypost',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.buyouts_flypost')))])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21b26b0d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/statistics/conversions/ConversionsTabs.vue
// module id = 528
// module chunks = 0